module.exports = __webpack_public_path__ + "img/header-weddingRingsFinishes@2x.e63a85f.jpg";